import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-border last:border-0" data-id="element-34">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 md:py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-35">
        <span className="text-base md:text-lg font-bold text-text-primary group-hover:text-coral transition-colors pr-4" data-id="element-36">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-text-secondary transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-37" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4 md:pb-6' : 'max-h-0 opacity-0'}`} data-id="element-38">
        <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-39">
          {answer}
        </p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Es esta guía para mí si mi hijo ya tiene 17 años?',
    answer: "Sí. Aunque las dinámicas cambian, los principios de 'Conexión Primero' aplican para adolescentes de 10 a 18 años. Los guiones y estrategias se adaptan a su nivel de madurez."
  }, {
    question: '¿Cuánto tiempo me tomará ver resultados?',
    answer: 'Muchas madres reportan una disminución en las discusiones en los primeros 7 días al cambiar su forma de abordar el tema. El cambio profundo en la relación toma alrededor de 30 días de consistencia.'
  }, {
    question: 'Mi hijo es muy rebelde y no escucha a nadie. ¿Funcionará?',
    answer: 'La rebeldía suele ser una respuesta a sentirse controlado o incomprendido. Esta guía te enseña exactamente cómo bajar esas defensas para que vuelva a estar dispuesto a escuchar.'
  }, {
    question: '¿Cómo recibo la guía?',
    answer: 'Inmediatamente después de tu compra, recibirás un correo electrónico con el enlace para descargar la guía en formato PDF, junto con todos los bonos. Puedes leerla en tu celular, tablet o computadora.'
  }, {
    question: '¿Qué pasa si la compro y siento que no me ayuda?',
    answer: 'Tienes una garantía incondicional de 7 días. Si lees la guía y sientes que no es para ti, solo envíanos un correo y te devolveremos el 100% de tu dinero, sin hacer preguntas.'
  }];
  return <section className="bg-primary py-10 md:py-24 px-4" data-id="element-40">
      <div className="max-w-3xl mx-auto" data-id="element-41">
        <div className="text-center mb-8 md:mb-12" data-id="element-42">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-43">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="bg-white rounded-2xl p-5 md:p-8 shadow-sm border border-border" data-id="element-44">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-45" />)}
        </div>
      </div>
    </section>;
}